/**
 * The House of Rule Zero — Theme Fixes (JS)
 * Horizon 4.1.1 (theme 153069027502)
 *
 * Fix: Hide blank rows inside product detail accordions.
 *
 * Product detail rows are group-block elements inside accordion .details-content
 * divs. Each row has two rte-formatter elements: label [0] and value [1].
 * When a product has no value for a field, the value block renders empty or absent.
 * This script hides any such row so blank entries never appear.
 *
 * Scoped to .details-content .group-block to avoid touching other group-blocks
 * (e.g. the product title block in the main product section).
 */

(function hideBlankProductDetailRows() {
  function run() {
    document.querySelectorAll('.details-content .group-block').forEach(function (row) {
      var contentDiv = row.children[1];
      if (!contentDiv) return;

      var formatters = contentDiv.querySelectorAll('rte-formatter');
      var valueFormatter = formatters[1];
      var hasValue = valueFormatter && valueFormatter.textContent.trim() !== '';
      if (!hasValue) {
        row.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
